import { Link } from "react-router-dom";
import logo from "@/assets/logo-optimized.webp";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="border-t border-border bg-background mt-auto pb-[env(safe-area-inset-bottom)]">
      <div className="container mx-auto px-6 py-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-8">
          {/* Product */}
          <div>
            <h3 className="text-sm font-semibold text-foreground mb-3">{t("footer.product", "Product")}</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/how-it-works" className="hover:text-foreground transition-colors">{t("footer.howItWorks", "How It Works")}</Link></li>
              <li><Link to="/features" className="hover:text-foreground transition-colors">{t("footer.features", "Features")}</Link></li>
              <li><Link to="/pricing" className="hover:text-foreground transition-colors">{t("footer.pricing", "Pricing")}</Link></li>
              <li><Link to="/applications" className="hover:text-foreground transition-colors">{t("footer.applications", "Applications")}</Link></li>
              <li><Link to="/api-docs" className="hover:text-foreground transition-colors">{t("footer.apiDocs", "API Docs")}</Link></li>
              <li><Link to="/mcp-docs" className="hover:text-foreground transition-colors">{t("footer.mcpDocs", "MCP Server")}</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-sm font-semibold text-foreground mb-3">{t("footer.company", "Company")}</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/about-us" className="hover:text-foreground transition-colors">{t("footer.aboutUs", "About Us")}</Link></li>
              <li><Link to="/blog" className="hover:text-foreground transition-colors">{t("footer.blog", "Blog")}</Link></li>
              <li><Link to="/help" className="hover:text-foreground transition-colors">{t("footer.help")}</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-sm font-semibold text-foreground mb-3">{t("footer.legal", "Legal")}</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/privacy-policy" className="hover:text-foreground transition-colors">{t("footer.privacy")}</Link></li>
              <li><Link to="/terms" className="hover:text-foreground transition-colors">{t("footer.terms")}</Link></li>
              <li><Link to="/imprint" className="hover:text-foreground transition-colors">{t("footer.imprint")}</Link></li>
              <li><Link to="/open-source-licenses" className="hover:text-foreground transition-colors">{t("footer.licenses", "Open Source Licenses")}</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <Link to="/" className="flex items-center gap-2">
            <img src={logo} alt="" className="h-6 w-6 object-contain" />
            <span className="text-sm text-muted-foreground">
              {t("footer.copyright", { year: new Date().getFullYear() })}
            </span>
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
